import { Component, OnInit, Input } from '@angular/core';
import { DwModalRef } from 'ng-quicksilver';
import { FxDapHttpClient } from '../../fx-http-client';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'save-comcond',
  template:
    `
  
  <div class="fx_modal_container" stytle="height: 200px;" appModalDrag>
    <form dw-form [formGroup]="addForm" class="fx_modal_form">
      <div dw-row [dwGutter]="10">
        <div dw-col dwXs="24" dwMd="18" dwLg="18" dwXl="18">
          <dw-form-input
            formControlName="label"
            dwLabel="{{'com-常用条件名称' | translate}}"
            dwLabelSpan="6"
            dwInputSpan="14"
            [dwRequired]="true">
          </dw-form-input>
        </div>
        <div dw-col dwXs="24" dwMd="6" dwLg="6" dwXl="6">
          <dw-form-item>           
            <dw-form-control>
              <label dw-checkbox formControlName="aan005" >
                <span>{{ 'com-默认查询条件' | translate}}</span>
              </label>
            </dw-form-control>
          </dw-form-item>
        </div>
        <div class="save-comcond_label" dw-col dwXs="24" dwMd="24" dwLg="24" dwXl="24">常用按钮</div>
        <div dw-col dwXs="24" dwMd="24" dwLg="24" dwXl="24">
          <button class="save-comcond_btn" dw-button [dwGhost]="item.selected ? true : false" [dwType]="item.selected ? 'primary' : 'default'" *ngFor="let item of btnList" (click)="selBtnItem(item)">{{item.name}}</button>
        </div>
        <div class="customize-footer">
          <button dw-button type="button" [dwType]="'default'" (click)="handleCancel()">{{ 'dw-cancel' | translate}}</button>
          <button dw-button [dwType]="'primary'" [disabled]="!addForm.valid" (click)="handleOk()">{{ 'dw-determine' | translate}}</button>
        </div>
      </div>
    </form>
    </div>
  
  `,
  styles: [
    `
    :host ::ng-deep .customize-footer {
      // border-top: 1px solid #e9e9e9;
      padding: 0;
      text-align: right;
      border-radius: 0 0 0px 0px;
      margin: 0;
    }
    :host ::ng-deep .ant-form-item-label {
      line-height: 24px;
    }
    :host ::ng-deep .ant-form-item-label label {
      font-size: 13px;
    }
    :host ::ng-deep .ant-layout-content {
      margin: -24px;
    }
    :host ::ng-deep .fx_modal_form {
      padding: 10px;
    }
    :host ::ng-deep .fx_modal_form .customize-footer button {
      padding: 0 15px;
      transition: 1s all;
    -webkit-transition: 1s all;
    }
    :host ::ng-deep .fx_modal_form .customize-footer button:first-child {
      background: #69c0ff;
      border-color: #69c0ff;
      color: #fff;
      box-shadow: 0 1px 6px #bae7ff;
    }
    :host ::ng-deep .fx_modal_form .customize-footer button:last-child {
      color: #fff;
      border-color: #1890ff;
      background: #1890ff;
      box-shadow: 0px 1px 6px 0px #72c0ff;
    }
    .customize-footer button:hover {
      border-color: #3aa7ff;
      background: #3aa7ff;
    }
    :host ::ng-deep .customize-footer button:last-child:hover {
      color: #fff;
      border-color: #0b79de;
      background: #0b79de; 
    }
    :host ::ng-deep .fx_modal_form .customize-footer .ant-btn-primary.disabled, 
    :host ::ng-deep .fx_modal_form .customize-footer .ant-btn-primary[disabled], 
    :host ::ng-deep .fx_modal_form .customize-footer .ant-btn-primary.disabled:hover, 
    :host ::ng-deep .fx_modal_form .customize-footer .ant-btn-primary[disabled]:hover, 
    :host ::ng-deep .fx_modal_form .customize-footer .ant-btn-primary.disabled:focus, 
    :host ::ng-deep .fx_modal_form .customize-footer .ant-btn-primary[disabled]:focus, 
    :host ::ng-deep .fx_modal_form .customize-footer .ant-btn-primary.disabled:active, 
    :host ::ng-deep .fx_modal_form .customize-footer .ant-btn-primary[disabled]:active, 
    :host ::ng-deep .fx_modal_form .customize-footer .ant-btn-primary.disabled.active, 
    :host ::ng-deep .fx_modal_form .customize-footer .ant-btn-primary[disabled].active {
      color: rgba(0, 0, 0, 0.25);
      background-color: #f5f5f5;
      border-color: #d9d9d9;
      box-shadow: 0 1px 6px #d9d9d9;
    }

    .save-comcond_label {
      font-weight: bold;
      margin: 16px 0;
    }

    .save-comcond_btn {
      margin: 0 10px 10px 0;
      padding: 7px 16px;
      line-height: 14px;
    }
    `
  ]
})
export class saveCondComponent implements OnInit {
  @Input() programId: string = '';// 作业编号
  public addForm: FormGroup;
  public btnList: Array<any> = []; // 有权限按钮

  constructor(
    private modalSubject: DwModalRef,
    private fb: FormBuilder,
    public http: FxDapHttpClient
  ) { }

  ngOnInit(): void {
    this.addForm = this.fb.group({});
    this.addForm.addControl('label', new FormControl('', Validators.required));
    this.addForm.addControl('aan005', new FormControl(false));
    // 获取权限按钮列表
    this.getAuthedButtonList();
  }

  handleOk(): void {
    const label = this.addForm.get('label').value;
    this.btnList.forEach(s => {
      s.adk004 = s.id; // 按钮编号
      s.adk005 = s.aaj003; // 按钮分组
    })
    console.log('保存', this.addForm);
    this.modalSubject.triggerOk();
  }

  handleCancel(): void {
    console.log('Button cancel clicked!');
    this.modalSubject.triggerCancel();
  }

  // 获取有权限按钮清单
  getAuthedButtonList() {
    this.http.post('A/IACommonService/showButtonDisplay', { param: { program_no: this.programId } }, { headers: { 'program-code': this.programId } }).subscribe(response => {
      if (response.success && response.data && response.data.length) {
        this.btnList = response.data;
      } else {
        this.btnList = [];
      }
    });
  }

  // 按钮选择
  selBtnItem(item) {
    item.selected = !item.selected;
  }

}